$(".invertible-slider-outer").slick({
  arrows: true,
  dots: true,
  infinite: false,
  autoplay: false,
  appendDots: $(".dots-invertible"),
  prevArrow: $(".prev-invertible"),
  nextArrow: $(".next-invertible"),
  asNavFor: ".invertible-slider-numbers,.flex-container__inner-img",
});
$(".flex-container__inner-img").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  fade: true,
  asNavFor: ".invertible-slider-outer,.invertible-slider-numbers",
});
$(".invertible-slider-numbers").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  fade: true,
  asNavFor: ".invertible-slider-outer,.flex-container__inner-img",
});

$(".image-slider-section").slick({
  arrows: true,
  dots: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 3,
  lazyLoad: "ondemand",
  slidesToScroll: 3,
  swipeToSlide: true,
  nextArrow:
    '<button class="slick-arrow flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  prevArrow:
    '<button class="slick-arrow flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        speed: 5000,
        dots: false,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        touchMove: false,
        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        speed: 5000,
        dots: false,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        touchMove: false,
        infinite: true,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".product-area__thumbs--inner").slick({
  arrows: false,
  dots: false,
  vertical: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  infinite: false,
  focusOnSelect: true,
  swipeToSlide: true,
  asNavFor: ".theme-images--inner, .product-area__thumbs--inner--mobile",
});

$(".product-area__thumbs--inner--mobile").slick({
  arrows: false,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: false,
  focusOnSelect: true,
  swipeToSlide: true,
  asNavFor: ".theme-images--inner, .product-area__thumbs--inner",
});

var numberOfItems = $(".theme-images--inner .swiper-slide-unsed").length; //get number of pictures on the slide
$(".theme-images--inner").slick({
  arrows: true,
  dots: true,
  infinite: false,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: "ondemand",
  fade: true,
  nextArrow:
    '<button class="slick-arrow flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  prevArrow:
    '<button class="slick-arrow flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
  asNavFor:
    ".product-area__thumbs--inner, .product-area__thumbs--inner--mobile",
});

function ClassDotsManager(slickElementId, numOfItems, numOfDots) {
  this.listDotsElement = $("." + slickElementId + " ul.slick-dots li");
  this.numOfDots = numOfDots <= numOfItems ? numOfDots : numOfItems;
  this.minIndex = 0;
  this.maxIndex = numOfDots - 1;
  this.showDotsBetween = function (minIndex, maxIndex) {
    this.listDotsElement.filter(function (index) {
      /*if(index >= minIndex && index <= maxIndex){
            $(this).show("fast");
          }else{
            $(this).hide("fast");
          }*/ console.log("Test " + minIndex + maxIndex);
      if (index >= minIndex && index <= maxIndex) {
        $(this).addClass("in-view");
        $(this).show("fast");
      } else {
        $(this).removeClass("in-view");
        $(this).hide("fast");
      }
    });
  };
  this.init = function () {
    this.showDotsBetween(0, this.numOfDots - 1);
  };
  this.updateDots = function (newIndex) {
    if (newIndex >= this.minIndex && newIndex <= this.maxIndex) {
      // don't need to update
    } else {
      if (newIndex > this.maxIndex) {
        this.maxIndex = newIndex;
        this.minIndex = this.maxIndex - this.numOfDots + 1;
      } else {
        this.minIndex = newIndex;
        this.maxIndex = this.minIndex + this.numOfDots - 1;
      }
      if (this.maxIndex % 5 == 0) {
        this.minIndex = this.minIndex + 4;
        this.maxIndex = this.maxIndex + 4;
      }
      this.showDotsBetween(this.minIndex, this.maxIndex);
      //$(".theme-images--inner .slick-dots").css("transform", `translateX(${$(".theme-images--inner .slick-dots .slick-active").innerWidth()}px)`)
      console.log(newIndex);
    }
  };
}

//=====================================================================
// usage (with "small-preview" is the id of div that is used for slick)
//=====================================================================

var dotsManager = new ClassDotsManager("theme-images--inner", numberOfItems, 5);
dotsManager.init();
console.log(numberOfItems);
//$(".theme-images--inner .slick-dots").wrap("<div class='slick-dots-viewport'></div>");

$(".theme-images--inner").on("afterChange", function (slick, currentSlide) {
  dotsManager.updateDots(currentSlide.currentSlide);
});

/*$(".section-product-template .product-slider").css(
  "margin-top",
  "-".concat($(".product-area__thumbs--inner").outerHeight(), "px")
);*/

const interval = setInterval(function () {
  $(".section-product-template .product-slider").css(
    "margin-top",
    "-".concat($(".product-area__thumbs--inner").outerHeight(), "px")
  );
}, 250);

setTimeout(function () {
  clearInterval(interval);
}, 15000);

$(".product-slider .slick-arrow").click(function () {
  $(".section-product-template .product-slider").css(
    "margin-top",
    "-".concat($(".product-area__thumbs--inner").outerHeight(), "px")
  );
});

$(".image-text-block-3-slider").slick({
  arrows: true,
  dots: true,
  infinite: false,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: "ondemand",
  swipeToSlide: true,
  fade: true,
  nextArrow:
    '<button class="slick-arrow flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  prevArrow:
    '<button class="slick-arrow flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
});

$(document).ready(function () {
  // (Optional) Active an item if it has the class "is-active"
  $(".faqs .accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown();
  $(".faqs .accordion .accordion-thumb").click(function () {
    // Cancel the siblings
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle();
    $(this).find(".icon").toggleClass("rotate--icons");
    // Toggle the item
    //$(this).closest(".accordion-item").toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});

$(document).ready(function () {
  $(".product-area .accordion .accordion-thumb").click(function () {
    // Cancel the siblings
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle();
    $(this).find(".icon").toggleClass("rotate--icons");
    // Toggle the item
    //$(this).closest(".accordion-item").toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});

// Add custom code below this line
setInterval(function time() {
  var d = new Date();
  var d1 = new Date();
  d.setHours(d1.getHours() + 12);
  var hours = 23 - d.getHours();
  var min = 60 - d.getMinutes();
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  var sec = 60 - d.getSeconds();
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }
  $(".timer").html(hours + ":" + min + ":" + sec);
}, 1000);

var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateNew = new Date(new Date().getTime() + 120 * 60 * 60 * 1000);
var day = currentDateNew.getDate();
let dayN = "th";
switch (day) {
  case 1:
    dayN = "st";
    break;
  case 2:
    dayN = "nd";
    break;
  case 3:
    dayN = "rd";
    break;
  default:
    dayN = "th";
}
var month = currentDate.getMonth() + 1;
var year = currentDate.getFullYear();
var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
$(".date-product").html(
  days[currentDateNew.getDay()] +
    " " +
    monthNames[currentDateNew.getMonth()] +
    " " +
    day +
    dayN
);

$(".product__submit__add-js").click(() => {
  $(".add-to-cart-button-js").click();
});

$(".cart-bar-container").hide();
$(document).scroll(function () {
  var y = $(this).scrollTop();
  if (y > 800) {
    $(".cart-bar-container").show();
  } else {
    $(".cart-bar-container").hide();
  }
});

function callback(entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      $(".cart-bar").fadeOut("fast");
    } else {
      $(".cart-bar").show();
    }
  });
}
var observer = new IntersectionObserver(callback);
observer.observe(document.getElementById("observer_id"));

$(window).scroll(function () {
  if ($("body").height() - 200 <= $(window).height() + $(window).scrollTop()) {
    document.getElementById("cart-bar").style.display = "none";
  } else {
    var observer2 = new IntersectionObserver(callback);
    observer2.observe(document.getElementById("observer_id"));
  }
});
